module.exports = __webpack_public_path__ + "img/mPfp46.6a208389.png";